import Alpine from 'alpinejs';
import ajax from '@imacrayon/alpine-ajax';
import focus from '@alpinejs/focus';
import htmx from 'htmx.org';

import './alert-ticker.js';

// Register Alpine plugins
Alpine.plugin(ajax);
Alpine.plugin(focus);

window.Alpine = Alpine;
window.htmx = htmx;

// Configure Alpine AJAX with WordPress nonce
document.addEventListener('alpine:init', () => {
    const wpNonce = window.wpApiSettings?.nonce || window.nonce;
    
    if (wpNonce) {
        // Configure Alpine AJAX headers
        Alpine.store('ajax', {
            headers: {
                'X-WP-Nonce': wpNonce,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }
});

// Configure HTMX if nonce is available
const wpNonce = window.wpApiSettings?.nonce || window.nonce;
if(wpNonce) {
    document.addEventListener('htmx:configRequest', function(event) {
        event.detail.headers['X-WP-Nonce'] = wpNonce;
    });
}

document.addEventListener('DOMContentLoaded', function() {
    Alpine.start();

    // Global popup trigger — any element with data-popup="slug" opens that popup
    document.addEventListener('click', function(e) {
        const trigger = e.target.closest('[data-popup]');
        if (trigger) {
            e.preventDefault();
            const slug = trigger.getAttribute('data-popup');
            const productName = trigger.getAttribute('data-quote-product');
            window.dispatchEvent(new CustomEvent('open-popup-' + slug));

            // Pre-select the product in the quote form dropdown
            if (productName) {
                setTimeout(function() {
                    document.querySelectorAll('#input_1_8').forEach(function(select) {
                        select.value = productName;
                        select.dispatchEvent(new Event('change', { bubbles: true }));
                    });
                }, 300);
            }
        }
    });
});

// Alpine.magic('blockData', (el, { Alpine }) => {
//     // el.parentElement.id is the key of the blockData object
//     let blockData = Alpine.store('blockData')[el.parentElement.id];
//     return blockData;
// });